export const catalog_matrix = [
  {form_key:'fiscal_situation_id', catalog_key:'fiscal_situations'},
  {form_key:'tributary_mailbox_status_id', catalog_key:'tributary_mailbox_statuses'},
  {form_key:'importers_list_id', catalog_key:'importer_list'},
  {form_key:'accounting_method_id', catalog_key:'accounting_methods'},
]